"use strict";
var __webpack_require__ = {};
(()=>{
    __webpack_require__.d = (exports1, definition)=>{
        for(var key in definition)if (__webpack_require__.o(definition, key) && !__webpack_require__.o(exports1, key)) Object.defineProperty(exports1, key, {
            enumerable: true,
            get: definition[key]
        });
    };
})();
(()=>{
    __webpack_require__.o = (obj, prop)=>Object.prototype.hasOwnProperty.call(obj, prop);
})();
(()=>{
    __webpack_require__.r = (exports1)=>{
        if ('undefined' != typeof Symbol && Symbol.toStringTag) Object.defineProperty(exports1, Symbol.toStringTag, {
            value: 'Module'
        });
        Object.defineProperty(exports1, '__esModule', {
            value: true
        });
    };
})();
var __webpack_exports__ = {};
__webpack_require__.r(__webpack_exports__);
__webpack_require__.d(__webpack_exports__, {
    initJwtPromiseCache: ()=>initJwtPromiseCache,
    storageSet: ()=>storageSet,
    storageGet: ()=>storageGet
});
const core_lib_namespaceObject = require("@bytecloud/core-lib");
const external_jwt_constant_js_namespaceObject = require("./jwt.constant.js");
const comon_js_namespaceObject = require("../utils/comon.js");
const initJwtPromiseCache = ()=>{
    try {
        if (!comon_js_namespaceObject.hasWindow) return {};
        if (!window.__bytecloud_shared__) window.__bytecloud_shared__ = {};
        if (!window.__bytecloud_shared__.jwtPromisesCache) window.__bytecloud_shared__.jwtPromisesCache = {};
        return window.__bytecloud_shared__.jwtPromisesCache;
    } catch (error) {
        return {};
    }
};
const storageGet = ()=>{
    try {
        if (comon_js_namespaceObject.hasWindow) return core_lib_namespaceObject.ls.get(external_jwt_constant_js_namespaceObject.MappedJwtStorageKey, {});
    } catch (error) {
        console.error(error);
    }
    return {};
};
const storageSet = (data, changedKey)=>{
    try {
        if (comon_js_namespaceObject.hasWindow) {
            core_lib_namespaceObject.ls.set(external_jwt_constant_js_namespaceObject.MappedJwtStorageKey, data);
            if (changedKey && data[changedKey]) window.localStorage.setItem(external_jwt_constant_js_namespaceObject.JwtStorageKey, data[changedKey]);
            else if (!Object.keys(data).length) window.localStorage.removeItem(external_jwt_constant_js_namespaceObject.JwtStorageKey);
        }
    } catch (error) {
        console.error(error);
    }
};
exports.initJwtPromiseCache = __webpack_exports__.initJwtPromiseCache;
exports.storageGet = __webpack_exports__.storageGet;
exports.storageSet = __webpack_exports__.storageSet;
for(var __webpack_i__ in __webpack_exports__)if (-1 === [
    "initJwtPromiseCache",
    "storageGet",
    "storageSet"
].indexOf(__webpack_i__)) exports[__webpack_i__] = __webpack_exports__[__webpack_i__];
Object.defineProperty(exports, '__esModule', {
    value: true
});
